/**
 * Detail windows of a speaker and of a who's who attendee (every theme): the photo as high as the informations on
 * its right (name, job title, company, country, links), whatever their number of lines. Their height is set in
 * --detail-photo-size, the styles keep the photo between its former size and 40% of the width of the header
 * (components/_event-content.scss).
 */
const MODALS = ['modal-speaker-details', 'modal-whoswho-details'];

const observed = new WeakSet();

const fit = (info) => {
    // On the window (wire:ignore.self: Livewire keeps its attributes when it renders another person)
    const target = info.closest(MODALS.map((id) => `#${id}`).join(',')) || info.closest('.detail-header');
    if (!target) return;

    const height = Math.round(info.getBoundingClientRect().height);
    const current = parseInt(target.style.getPropertyValue('--detail-photo-size'), 10) || 0;

    // Again only for a real change (the photo changes the width of the informations, so their height)
    if (height > 0 && Math.abs(height - current) > 1) {
        target.style.setProperty('--detail-photo-size', `${height}px`);
    }
};

const resizeObserver = typeof ResizeObserver === 'undefined'
    ? null
    : new ResizeObserver((entries) => entries.forEach((entry) => fit(entry.target)));

const fitModal = (modal) => {
    modal.querySelectorAll('.detail-info').forEach((info) => {
        fit(info);
        if (resizeObserver && !observed.has(info)) {
            resizeObserver.observe(info);
            observed.add(info);
        }
    });
};

// The window is filled by Livewire on a click, then shown by Bootstrap (its events bubble)
document.addEventListener('shown.bs.modal', (event) => {
    if (MODALS.includes(event.target?.id)) {
        fitModal(event.target);
    }
});
